module.exports = new __parcel__URL__("SOLARIS-01-LOGO.5bab14fa.png").toString();